import React, {useState, useEffect} from 'react';
import Header from './Header';
import Loading from './Loading';
import {REFERRAL_NULL, TIME_OUT} from '../staticTypes'
import { getRefCompleted } from '../../Utils/blogs'

const ReferralDetail = (props) => {
	const { points } = props.data;
	const { onClick, launcherFlag, email } = props;
	const [loading, setLoading] = useState(true);
	const [lists, setLists] = useState([])

	useEffect((email) => {
		getRefCompleted(email).then((res) => {
			if (res.code === 200) {
				const result = res.result
				setLists(result);
				setLoading(false)
			}
		}).catch((err) => {
			console.log(err)
		})
		setTimeout(() => {
			setLoading(false)
		}, TIME_OUT)
		return () => {
			setLists([]);
			setLoading(true)
		};
	}, []);
	
	return (
		<div id="point-activity" className="point-activity-rewards">
			<Header points={points} onClick={onClick} launcherFlag={launcherFlag} link="/" />

			<div className="panel-container with-wantdo-footer">
				<div className="panel-subview">
					<div className="card-list-container ">

						<div>
							<div className="card-heading-container">
								<div className="card-title heading">Points activity</div>

							</div>
							<div className="card-list-container ">

								{
									loading === true ?
										<Loading />
										:
										lists.length > 0 ?
											lists.map((item, key) => {
												return (
													<div className="card-list-item-container" key={key}>
														<div className="card-list-item no-hover no-image align-items-start" aria-label="Points spent on $1 off coupon">
															<div className="card-list-item-content">
																<div className="list-item-text-wrapper">
																	<div className="list-item-title">{item.event}</div>
																	<div className="list-item-subtitle text-muted" style={{ marginTop: '4px' }}>{item.points} points</div>
																</div>
															</div>
															<div className="text-muted text-nowrap">Jan 13, 2021</div>
														</div>
													</div>
												)
											})
											:
											<div className="card-list-item-container no-images"  style={{ paddingLeft: '12px'}}>
												{REFERRAL_NULL}
											</div>

								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
 
export default ReferralDetail;